module.exports = __webpack_public_path__ + "static/media/compras.03201a8d.svg";